export type TourStepDefinition = {
  selector: string;
  title: string;
  description: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
};

export const APP_TOUR_STEPS: TourStepDefinition[] = [
  {
    selector: '[data-tour="period"]',
    title: "期間を選択",
    description: "開始日（月曜日）を選択すると、1週間分の日付が自動で設定されます。",
    side: "right",
  },
  {
    selector: '[data-tour="schedule01"]',
    title: "週間スケジュールを入力",
    description: "各曜日の配信時間と内容を入力します。チェックを入れると、その日はお休み表示になります。",
    side: "right",
  },
  {
    selector: '[data-tour="schedule02"]',
    title: "お休みテキストを変更",
    description: "お休みの日に表示するテキストを変更できます。未入力の場合は「配信おやすみ」が表示されます。",
    side: "right",
  },
  {
    selector: '[data-tour="images"]',
    title: "画像を追加",
    description: "ロゴ画像とメインイラストを設定できます。プレビュー上で位置やサイズも調整できます。",
    side: "right",
  },
  {
    selector: '[data-tour="andmore"]',
    title: "文字情報を追加",
    description: "クレジットや注釈、コメントを追加できます。クレジットとコメントは、プレビュー上で位置を調整できます。",
    side: "right",
  },
  {
    selector: '[data-tour="design"]',
    title: "デザインを選択",
    description: "テンプレートとカラーテーマを切り替えて、お好みのデザインに変更できます。",
    side: "left",
  },
  {
    selector: '[data-tour="preview"]',
    title: "仕上がりを確認",
    description: "プレビューを見ながら画像や文字の位置を調整できます。「画像を生成」から保存／コピー／共有できます。",
    side: "left",
    align: "end",
  },
  {
    selector: '[data-tour="about"]',
    title: "このツールについて",
    description: "利用規約やプライバシーポリシーなどはこちらから確認できます。",
    side: "left",
  },
];
